// extracted by mini-css-extract-plugin
export default {"container":"people_container__1m_KN","isDark":"people_isDark__3yqpH","items":"people_items__12yyP","item":"people_item__1nmut"};